export const convertShortcodeBox = (text: string): string => {
  const start = '[ADD_BOX::START]';
  const end = '[ADD_BOX::END]';

  const indexStart = text.indexOf(start);
  if (indexStart === -1) {
    return text;
  }

  const indexEnd = text.indexOf(end, indexStart + start.length);
  if (indexEnd === -1) {
    // Fail-open for unmatched start markers.
    return text;
  }

  const textBefore = text.slice(0, indexStart).replace(/\s*$/, '');
  const boxContent = text.slice(indexStart + start.length, indexEnd).trim();
  const remainingText = text.slice(indexEnd + end.length).replace(/^\s*/, '');

  const boxMarkup = `<div data-et-box="true">${boxContent}</div>`;
  const textAfter = remainingText === '' ? '' : convertShortcodeBox(remainingText);

  return `${textBefore}${boxMarkup}${textAfter}`;
};
